import "./skills.css";
import "react-multi-carousel/lib/styles.css";
import reactjs from "../../assets/logos/reactjs.png";
import svelte from "../../assets/logos/svelte.png";
import typescript from "../../assets/logos/typescript.png";
import springboot from "../../assets/logos/springboot.png";
import django from "../../assets/logos/django.png";
import kotlin from "../../assets/logos/kotlin.png";
import python from "../../assets/logos/python.png";
import java from "../../assets/logos/java.png";
import jenkins from "../../assets/logos/jenkins.png";
import docker from "../../assets/logos/docker.png";
import jboss from "../../assets/logos/jboss.png";
import terraform from "../../assets/logos/terraform.png";
import apache from "../../assets/logos/apache.png";
import aws from "../../assets/logos/aws.png";
import mariadb from "../../assets/logos/mariadb.png";
import oracle from "../../assets/logos/oracle.png";
import {Col, Container, Nav, Row, Tab} from "react-bootstrap";
import 'animate.css';
import {useState, forwardRef} from "react";
import CarouselComponent from "../../components/CarouselComponent";
import { useLanguage } from "../../context/LanguageContext";

const frontendArray = [
    {src: reactjs, title: 'ReactJS / Native'},
    {src: svelte, title: 'Svelte'},
    {src: typescript, title: 'TypeScript'},
];

const backendArray = [
    {src: springboot, title: 'Spring Boot'},
    {src: django, title: 'Django'},
    {src: kotlin, title: 'Kotlin'},
    {src: python, title: 'Python'},
    {src: java, title: 'Java'},
    {src: mariadb, title: 'MariaDb'},
    {src: oracle, title: 'Oracle'},
];

const cicdArray = [
    {src: jenkins, title: 'Jenkins'},
    {src: docker, title: 'Docker'},
    {src: jboss, title: 'JBoss'},
    {src: terraform, title: 'Terraform'},
    {src: apache, title: 'Apache'},
];

const cloudArray = [
    {src: aws, title: 'AWS'},
];

const Skills = forwardRef<HTMLElement>((props, ref) => {
    const [tabSelected, setTabSelected] = useState("first");
    const { t } = useLanguage();

    return (
        <section className="skill" id="Skills" ref={ref}>
            <Container fluid="xl">
                <Row className="justify-content-center text-center p-4">
                    <Col xs={12} md={10} lg={8}>
                        <h2 className="text-center">{t('skills.title')}</h2>
                        <p className="text-center mx-auto">{t('skills.description')}</p>
                    </Col>
                </Row>

                <Row className="container-slider">
                    <Col size={12}>
                        <div className="skills-content-wrapper">
                            <Tab.Container id="skills-tabs" activeKey={tabSelected} onSelect={(key) => setTabSelected(key || "first")}>
                                <Nav variant="pills"
                                     className="nav-pills mb-5 justify-content-center align-items-center"
                                     id="pills-tab">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">Frontend</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="second">Backend</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="third">CI/CD</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="fourth">Cloud</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content id="slideInUp">
                                    <Tab.Pane eventKey="first">
                                        <CarouselComponent arrayLogos={frontendArray}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <CarouselComponent arrayLogos={backendArray}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="third">
                                        <CarouselComponent arrayLogos={cicdArray}/>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="fourth">
                                        <CarouselComponent arrayLogos={cloudArray}/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
});

export default Skills;
